import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo3 } from "../../../routes/Module3";
import Imagen1 from "../../../images/modulo3/postit1.png";
import Imagen2 from "../../../images/modulo3/postit2.png";
import Imagen3 from "../../../images/modulo3/postit3.png";

import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo3/Actividad 8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo3.content[0];
  const infoAct = modulo3.content[0].activities[7];
  const crumbs = [
    {
      title: modulo3.title,
      url: "/" + modulo3.url,
    },
    {
      title:
        modulo3.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `Cierre`,
    linkNext: `${modulo3.url}/cierre`,
    titlePrev: `${modulo3.content[0].activities[6].name}`,
    linkPrev: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title} - ${infoAct.name}`,
    name: modulo3.title
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo3.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">Actividad 8</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Piensa en algunos problemas de tu escuela y en cómo podrían
          solucionarlos.
        </li>
        <li>
          Elabora un cartel donde ilustres con un dibujo la solución al problema
          elegido.
        </li>
        <li>Puedes usar papel o papelote, colores o plumones.</li>
        <li>Aquí te proponemos algunos ejemplos de problemas.</li>
      </ul>

      <div className="row my-5">
        <div className="col-lg-3 col-md-6 col-12">
          <img src={Imagen1} alt="img" className="img-fluid" />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <img src={Imagen2} alt="img" className="img-fluid" />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <img src={Imagen3} alt="img" className="img-fluid" />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y los problemas seleccionados. Conversen acerca
          de los problemas de la escuela. Si no se les ocurre ninguno, pueden
          usar los ejemplos que se proporcionan en la actividad. Escojan uno,
          piensen en una solución y elaboren un cartel al respecto. Finalice
          conversando sobre el producto elaborado.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
